import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emh-stage-campaign-item__purchase-price-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dh_price_display_value = _resolveComponent("dh-price-display-value")!
  const _component_AdditionalData = _resolveComponent("AdditionalData")!
  const _component_dh_price_display_price_breakdown = _resolveComponent("dh-price-display-price-breakdown")!
  const _component_dh_price_display_omnibus = _resolveComponent("dh-price-display-omnibus")!
  const _component_dh_price_display_additional_price_information = _resolveComponent("dh-price-display-additional-price-information")!
  const _component_dh_price_display = _resolveComponent("dh-price-display")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.hostCssClass)
  }, [
    _createVNode(_component_dh_price_display, {
      locale: _ctx.locale,
      loading: "lazy",
      ".product": _ctx.product,
      environment: _ctx.plsEnvironment,
      "config-environment": _ctx.plsEnvironment,
      ".footnote-references": _ctx.footnoteReferences,
      "customer-type": _ctx.userContext,
      "post-code": { postCode: _ctx.postCode },
      onPdinitialize: _ctx.onPriceDisplayDataUpdate,
      onPdupdate: _ctx.onPriceDisplayDataUpdate
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.t('dcp.sfp.stageCampaign.purchasePrice.from')), 1),
          _createVNode(_component_dh_price_display_value, {
            type: "purchase-price",
            onPdfootnotereferenceclick: _ctx.scrollToFootnotes
          }, null, 8, ["onPdfootnotereferenceclick"]),
          _createVNode(_component_dh_price_display_price_breakdown, {
            onPdbreakdownopen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPpBreakdownToggle(true))),
            onPdbreakdownclose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPpBreakdownToggle(false)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AdditionalData, {
                language: _ctx.language,
                "slot-name": "additionalData",
                t: _ctx.t,
                product: _ctx.product
              }, null, 8, ["language", "t", "product"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_dh_price_display_omnibus),
        _createVNode(_component_dh_price_display_additional_price_information, { onPdfootnotereferenceclick: _ctx.scrollToFootnotes }, null, 8, ["onPdfootnotereferenceclick"])
      ]),
      _: 1
    }, 8, ["locale", ".product", "environment", "config-environment", ".footnote-references", "customer-type", "post-code", "onPdinitialize", "onPdupdate"])
  ], 2))
}